import { useQuery } from '@tanstack/vue-query';
import { getHeader } from '../api';

export default function useGetHeader(type: 'default' | 'business') {
  const { locale } = useI18n();

  const key =
    type && type === 'business'
      ? ['business-header', locale]
      : ['header', locale];

  const { data, suspense } = useQuery({
    queryKey: key,
    queryFn: () => getHeader(locale.value, type),
  });

  onServerPrefetch(async () => {
    await suspense();
  });

  return data;
}
